var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionalAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3137 3.96675C14.5537 2.982 15.4417 2.25 16.5 2.25C17.742 2.25 18.75 3.258 18.75 4.5V16.5C18.75 17.742 17.742 18.75 16.5 18.75C15.4417 18.75 14.5537 18.018 14.3137 17.0333L7.22175 14.196C6.93675 14.0827 6.75 13.8068 6.75 13.5V7.5C6.75 7.19325 6.93675 6.91725 7.22175 6.804L14.3137 3.96675ZM8.25 12.9923L15.2782 15.804C15.5633 15.9173 15.75 16.1932 15.75 16.5C15.75 16.914 16.086 17.25 16.5 17.25C16.914 17.25 17.25 16.914 17.25 16.5V4.5C17.25 4.086 16.914 3.75 16.5 3.75C16.086 3.75 15.75 4.18425 15.75 4.5C15.75 4.93275 15.2782 5.196 15.2782 5.196L8.25 8.00775V12.9923Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.75H4.5C3.258 6.75 2.25 7.758 2.25 9V12C2.25 13.242 3.258 14.25 4.5 14.25H7.5C7.914 14.25 8.25 13.914 8.25 13.5C8.25 13.086 7.914 12.75 7.5 12.75H4.5C4.086 12.75 3.75 12.414 3.75 12V9C3.75 8.586 4.086 8.25 4.5 8.25H7.5C7.914 8.25 8.25 7.914 8.25 7.5C8.25 7.086 7.914 6.75 7.5 6.75ZM18 9H19.5C19.914 9 20.25 9.336 20.25 9.75V11.25C20.25 11.664 19.914 12 19.5 12H18C17.586 12 17.25 12.336 17.25 12.75C17.25 13.164 17.586 13.5 18 13.5H19.5C20.742 13.5 21.75 12.492 21.75 11.25V9.75C21.75 8.508 20.742 7.5 19.5 7.5H18C17.586 7.5 17.25 7.836 17.25 8.25C17.25 8.664 17.586 9 18 9Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13.5V19.5C3 20.742 4.008 21.75 5.25 21.75C6.492 21.75 7.5 20.742 7.5 19.5V13.5C7.5 13.086 7.164 12.75 6.75 12.75C6.336 12.75 6 13.086 6 13.5V19.5C6 19.914 5.664 20.25 5.25 20.25C4.836 20.25 4.5 19.914 4.5 19.5V13.5C4.5 13.086 4.164 12.75 3.75 12.75C3.336 12.75 3 13.086 3 13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionalAlerts);
export default __webpack_public_path__ + "static/media/promotional-alerts.c7f6616bc85639a44afec98c7506a0c1.svg";
export { ForwardRef as ReactComponent };